<template>
  <div class="header">
    <a href="https://www.aeroiot.cn" target="_blank" class="business">
      <el-image v-if="logo" :src="logo" class="self-logo" fit="contain"></el-image>
    </a>
    <div class="admin aeroiotflex_row">      
      <!-- <img @click="mouseCLick" src="../assets/组 4965.png" />
      <span>{{user.displayName}}</span> -->
      <!-- <span>admin</span> -->
      <a class="accountmanage" :underline="false" :href="`${ioturl}/#/index/userrights`">用户管理</a>
      <i class="account-line"></i>
      <el-row style="width:160px">
        <el-col :span="6">
          <img src="../assets/组 4965.png" />
        </el-col>            
        <el-col :span="14">
          <div class="desc">
            <span>{{user.displayName}}</span>                
          </div>
        </el-col>
        <el-col :span="4">
          <div @click="mouseCLick" style="cursor: pointer;">
            <i class="el-icon-s-tools"></i>
          </div>
        </el-col>
      </el-row>
      <div :class="[isActive ? 'toobar' : 'toobars']">
        <div class="export">
          <div @click="logout">退出登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken,getCookie,removeCookie, getTicket } from "../utils/auth";
import mqtt from 'mqtt'
import axios from 'axios';
import store from '../store';
import config from '../utils/config'

export default {
  name: "HeaderItem",
  data() {
    return {
      isActive: false,
      user: {},
      client: {},
      logo: null,
      ioturl:config.iotUrl
    };
  },
  mounted:function(){
    this.loadUserInfo();
    this.connect();
    //this.loadOrgLogo();
  },
  methods: {
    mouseCLick() {
      this.isActive = !this.isActive;
    },
    logout() {
      //var redirect = getCookie(config.redirectKey);
      // 单点登录token
      removeToken();
      // 跳转传参token,redirect
      //removeCookie(config.tokenKey);
      // removeCookie(config.redirectKey);      
      window.location.href = this.$apis.logout;
    },
    loadUserInfo(){
      var userInfoApi = this.$apis.userinfo;
      this.$axios.get(userInfoApi).then(
           response => {
              if (response.status === 200 && response.data) {    
                  var result = response.data;
                  if(result.code === 200){
                    const data =  result.data
                    this.user = data;    
                    if(data.logo){
                      this.logo = data.logo;
                    }else{
                      this.logo="/static/images/logo.png"
                    };
                    this.changeico(data);
                  }else{
                    // console.log('用户查询失败:' + result.message);
                  }                                  
              }
              else{
                  // console.log('用户查询失败:' + response.message);
              } 
          },
          error => {
            // console.log('用户详情接口调用失败:' + error.message);
          }
      );
    },
    changeico(data) {
      const iconUrl = data.icon;
      if(!iconUrl)return;
      // 动态修改网站图标
      let favicon = document.querySelector('link[rel="icon"]');
      if (favicon !== null) {
        favicon.href = iconUrl;
      } else {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        favicon.href = iconUrl;
        document.head.appendChild(favicon);
      }
    },
    loadOrgLogo(){
      var orgLogoApi = this.$apis.orgLogo;
      this.$axios.get(orgLogoApi).then(
           response => {
              if (response.status === 200 && response.data) {    
                  var result = response.data;
                  if(result.code === 200){
                    var selfDefineLogo = result.data;
                    if(selfDefineLogo){
                      this.logo = selfDefineLogo;
                    }else{
                      this.logo="/static/images/logo.png"
                    }
                  }else{
                    // console.log('用户查询失败:' + result.message);
                  }                                  
              }
              else{
                  // console.log('用户查询失败:' + response.message);
              } 
          },
          error => {
            // console.log('用户详情接口调用失败:' + error.message);
          }
      );
    },
          //连接服务器
    connect() {
      this.client = mqtt.connect(config.mqtt.SSO_MQTT_SERVER, config.mqtt.ssoOpeions);
      this.client.on("connect", (e)=>{
        // console.log("成功连接服务器:",e);
        //订阅主题
        this.client.subscribe(['IDENTITY_USER_TOPIC'], { qos: 1 }, (err)=> {
          if (!err) {
            // console.log("订阅成功: IDENTITY_USER_TOPIC");
          } else {
            // console.log('消息订阅失败！')
          }
        });
      });
      //重新连接
      this.reconnect()
      //是否已经断开连接
      this.mqttError()
      //监听获取信息
      this.getMessage()
    },
    //监听接收消息
    getMessage() {
      this.client.on("message", (topic, message) => {
        if(message) {
          // console.log('收到来至',topic,'的信息',message.toString())
          const res = JSON.parse(message.toString())
          var actionType = res.actionType;
          var content = res.content;
          // console.log("action:" + actionType + ',content:' + content)
          switch(actionType) {
            case 'LOGOUT' :
              var coreInfo = JSON.parse(content.toString());
              var invalidUser = coreInfo.username;
              var logoutTicket = coreInfo.ticket;
              if(invalidUser && invalidUser === this.user.username){
                var tokenTicket = getTicket();
                if(!tokenTicket){
                  this.logout();
                }
                if(logoutTicket && logoutTicket === tokenTicket){
                  this.logout();
                }   
                // this.logout();             
              }
              break;
            case 'DELETE':
            case 'PASSWORD_CHANGE':
              var coreInfo = JSON.parse(content.toString());
              var invalidUser = coreInfo.username;
              if(invalidUser && invalidUser === this.user.username){
                  this.logout();
              }
              break;
            default:
              return
          }
        }
      });
    },
    //监听服务器是否连接失败
    mqttError() {
      this.client.on('error',(error) => {
        console.log('连接失败：',error)
        this.client.end()
      })
    },
    //监听服务器重新连接
    reconnect() {
      this.client.on('reconnect', (error) => {
          console.log('正在重连:', error)
      });
    },
    //断开连接
    unconnect() {
      this.client.end()
      this.client = null
      console.log('服务器已断开连接！')
    },
    //取消订阅
    unsubscribe(topic) {
      this.client.unsubscribe(topic, (error)=> {
        console.log('主题为'+ topic +'取消订阅成功',error)
      })
    }
  }
};
</script>

<style>
a {
  text-decoration: none;
  color: white;
}
.header {
  width: 100%;
  height: 50px;
  background-color: black;
  z-index: 10;
  position: fixed;
  top: 0;
}
.business {
  position: absolute;
  top: 7px;
  left: 31px;
  font-size: 20px;
  font-weight: bold;
  color: white;
}
.header .admin {
  position: absolute;
  top: 13px;
  right: 23px;
  color: white;
  height: 15px;
}
.accountmanage{
  color: #FFFFFF;
  font-size: 13px;
}
.account-line{
  width: 1px;
  height: 15px;
  background-color: #FFFFFF;
  margin: 0 20px;
}
.header .admin span {
  /* position: absolute; */
  font-size: 10px;
  /* top: 2px; */
  /* right: -10px; */
  margin-left: 5px;
}
.header .admin .toobars {
  display: none;
}
.header .admin .toobar .export {
  width: 84px;
  height: 41px;
  color: white;
  font-size: 14px;
  line-height: 41px;
  text-align: center;
  background-color: black;
}
.header .admin .toobar {
  cursor: pointer;
  display: block;
  position: absolute;
  top: 38px;
  right: 0px;
  width: 84px;
  height: 200px;
}

.self-logo{
  position:absolute;
  /* top:0; */
  /* bottom:0; */
  left:0;
  right:0;
  width: 120px;
  height: 36px;
  margin:auto;
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderItem.vue